import React, { useState,useEffect } from "react";
import { motion } from "framer-motion";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaClock,
  FaWhatsapp,
} from "react-icons/fa";
import aboutHero from "../assets/images/about-hero.jpg";
import Swal from "sweetalert2";

const Contact = () => {
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
    mobile_number: "",
    message: "",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/admin/create_contactUs`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
  
      const data = await res.json();
  
      if (res.ok) {
        setFormData({
          fullname: "",
          email: "",
          mobile_number: "",
          message: "",
        });
  
        Swal.fire({
          icon: "success",
          title: "Message Sent!",
          text: data.message || "Your message was successfully submitted.",
          confirmButtonColor: "#facc15", 
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: data.message || "Something went wrong.",
          confirmButtonColor: "#f87171", 
        });
      }
    } catch (error) {
      console.error("Submit error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Unable to submit form. Please try again later.",
        confirmButtonColor: "#f87171",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 w-full overflow-x-hidden">
      {/* Hero Section */}
      <section className="relative h-[30vh] sm:h-[35vh] md:h-[40vh] bg-gradient-to-r from-blue-900 to-indigo-800">
        <div
          className="absolute inset-0 opacity-20"
          style={{ backgroundImage: `url(${aboutHero})` }}
        ></div>
        <div className="relative h-full max-w-7xl mx-auto px-3 sm:px-4 md:px-6 flex items-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-white"
          >
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-2 sm:mb-3 md:mb-4">Contact Us</h1>
            <p className="text-base sm:text-lg md:text-xl text-gray-300">Get in touch with our team</p>
          </motion.div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-8 sm:py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6">
          <div className="grid md:grid-cols-2 gap-6 sm:gap-8 md:gap-12">
            {/* Contact Form */}
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="bg-white rounded-xl sm:rounded-2xl shadow-xl p-4 sm:p-6 md:p-8"
            >
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-4 sm:mb-6 md:mb-8 text-gray-800">
                Send us a Message
              </h2>
              <form className="space-y-4 sm:space-y-5 md:space-y-6" onSubmit={handleSubmit}>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
                  <div>
                    <label className="block text-gray-700 mb-1 sm:mb-2 text-sm sm:text-base">
                      Full Name
                    </label>
                    <input
                      type="text"
                      name="fullname"
                      value={formData.fullname}
                      onChange={handleChange}
                      className="w-full px-3 sm:px-4 py-2 sm:py-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-yellow-400 focus:border-transparent text-sm sm:text-base"
                      placeholder="John Doe"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-gray-700 mb-1 sm:mb-2 text-sm sm:text-base">
                      Email Address
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full px-3 sm:px-4 py-2 sm:py-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-yellow-400 focus:border-transparent text-sm sm:text-base"
                      placeholder="john@example.com"
                      required
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-gray-700 mb-1 sm:mb-2 text-sm sm:text-base">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    name="mobile_number"
                    value={formData.mobile_number}
                    onChange={handleChange}
                    className="w-full px-3 sm:px-4 py-2 sm:py-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-yellow-400 focus:border-transparent text-sm sm:text-base"
                    placeholder="+91 98765 43210"
                    required
                  />
                </div>
                <div>
                  <label className="block text-gray-700 mb-1 sm:mb-2 text-sm sm:text-base">Message</label>
                  <textarea
                    name="message"
                    rows="4"
                    value={formData.message}
                    onChange={handleChange}
                    className="w-full px-3 sm:px-4 py-2 sm:py-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-yellow-400 focus:border-transparent text-sm sm:text-base"
                    placeholder="Your message here..."
                    required
                  ></textarea>
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-gradient-to-r from-yellow-400 to-yellow-500 text-gray-900 font-semibold px-4 sm:px-6 md:px-8 py-3 sm:py-4 rounded-lg hover:shadow-lg transition-shadow duration-300 text-sm sm:text-base"
                >
                  {loading ? "Sending..." : "Send Message"}
                </button>

              </form>
            </motion.div>

            {/* Contact Information */}
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="space-y-4 sm:space-y-6 md:space-y-8"
            >
              <div className="bg-white rounded-xl sm:rounded-2xl shadow-xl p-4 sm:p-6 md:p-8">
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-4 sm:mb-6 md:mb-8 text-gray-800">
                  Contact Information
                </h2>
                <div className="space-y-4 sm:space-y-5 md:space-y-6">
                  <div className="flex items-start space-x-3 sm:space-x-4">
                    <div className="bg-yellow-100 p-2 sm:p-3 rounded-lg">
                      <FaMapMarkerAlt className="text-yellow-600 text-lg sm:text-xl" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-800 mb-1 text-sm sm:text-base">
                        Office Address
                      </h3>
                      <p className="text-gray-600 text-xs sm:text-sm md:text-base">
                        567 Saha Urf Pipalgaon Near IIIT-A Chauraha 211012
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3 sm:space-x-4">
                    <div className="bg-yellow-100 p-2 sm:p-3 rounded-lg">
                      <FaPhoneAlt className="text-yellow-600 text-lg sm:text-xl" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-800 mb-1 text-sm sm:text-base">
                        Phone Number
                      </h3>
                      <p className="text-gray-600 text-xs sm:text-sm md:text-base">
                        +91 9555562580 , +91 6394342072
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3 sm:space-x-4">
                    <div className="bg-yellow-100 p-2 sm:p-3 rounded-lg">
                      <FaEnvelope className="text-yellow-600 text-lg sm:text-xl" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-800 mb-1 text-sm sm:text-base">
                        Email Address
                      </h3>
                      <p className="text-gray-600 text-xs sm:text-sm md:text-base">
                        prayagproperties2020@gmail.com ,
                        mishraconstruction2904@gmail.com
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3 sm:space-x-4">
                    <div className="bg-yellow-100 p-2 sm:p-3 rounded-lg">
                      <FaClock className="text-yellow-600 text-lg sm:text-xl" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-800 mb-1 text-sm sm:text-base">
                        Working Hours
                      </h3>
                      <p className="text-gray-600 text-xs sm:text-sm md:text-base">24/7 Service Available</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* WhatsApp Button */}
              <motion.a
                href="https://wa.me/919555562580"
                whileHover={{ scale: 1.05 }}
                className="flex items-center justify-center space-x-2 sm:space-x-3 bg-green-500 text-white py-3 sm:py-4 px-4 sm:px-6 md:px-8 rounded-lg hover:bg-green-600 transition-colors"
              >
                <FaWhatsapp className="text-xl sm:text-2xl" />
                <span className="font-semibold text-sm sm:text-base">Chat on WhatsApp</span>
              </motion.a>

              {/* Map */}
              <div className="bg-white rounded-xl sm:rounded-2xl shadow-xl p-4 sm:p-6 md:p-8">
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-4 sm:mb-6 md:mb-8 text-gray-800">
                  Location Map
                </h2>
                <div className="h-[200px] sm:h-[250px] md:h-[300px] rounded-lg overflow-hidden">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d1801.627566092389!2d81.76728193837714!3d25.429732516729665!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1s%20567%20Saha%20Urf%20Pipalgaon%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20Near%20IIIT-A%20Chauraha%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20211012!5e0!3m2!1sen!2sin!4v1743835419597!5m2!1sen!2sin"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowfullscreen=""
                    loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
